import * as React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TooltipMUI, { TooltipProps as TooltipMUIProps } from '@material-ui/core/Tooltip';



type TooltipProps = {
	content: React.ReactNode;
	interactive?: boolean;
} & Omit<TooltipMUIProps,
	'title'
	| 'interactive'>

const useStyles = makeStyles(theme => ({
  tooltip: {
		backgroundColor: 'rgb(62, 71, 87)',
		fontWeight: 400,
		fontSize: 12,
		padding: 10,
		borderRadius: 0,
		lineHeight: 1.4
  },
}));

const Tooltip: React.SFC<TooltipProps> = (props) => {
	const { content, interactive, ...rest } = props;
  const classes = useStyles({});

  return (
    <TooltipMUI
			{...rest}
			interactive={interactive}
			classes={classes}
      title={
        <React.Fragment>
					{content}
        </React.Fragment>
      } 
		/>
  );
}

Tooltip.displayName = 'Tooltip';
Tooltip.defaultProps = {};

export default Tooltip;
